if (!customElements.get('product-engraving')) {
  customElements.define('product-engraving',
    class ProductEngraving extends HTMLElement {
      constructor() {
        super();         
      }
    
      connectedCallback() {        
        this.elements = {
          selects: this.querySelectorAll('.typography-field select')
        };
    
        this.setupEventListeners();
      }
    
      // Creates the event listeners
      setupEventListeners() {
        this.elements.selects.forEach((element) => {
          element.addEventListener('change', this.onSelectChange.bind(this));
        });
      }
    
      // On typography select change
      onSelectChange(event) {   
        event.stopImmediatePropagation();
        
        var target = event.target,
            fontFamily = target.value;
        
        target.style.fontFamily = fontFamily;
        target.closest('.fieldset').querySelector('input[type="text"]').style.fontFamily = fontFamily;
      }     
    }
  );
}